import { jsx as _jsx } from "react/jsx-runtime";
import { MyPlaylistsList } from '../features/savedItems';
export const MyPlaylists = () => {
  return /*#__PURE__*/_jsx(MyPlaylistsList, {});
};
export default MyPlaylists;